import React from 'react';
import mime from 'mime';

import { Doc, Media, Wrapper } from 'widget/components';
import { MsgText } from '../components';
import { useMsgContext } from '../../msg-context';

import Audio from './audio/audio';

const File = () => {
  const { msg } = useMsgContext();

  const type = mime.getType(msg.file_url);
  const isAudio = type?.startsWith('audio');
  const isMedia = type?.startsWith('image') || type?.startsWith('video');

  return (
    <Wrapper flexDirection="column" gap={4}>
      {isAudio ? (
        <Audio />
      ) : isMedia ? (
        <Media src={msg.file_url} />
      ) : (
        <Doc src={msg.file_url} />
      )}

      {msg.content && <MsgText>{msg.content}</MsgText>}
    </Wrapper>
  );
};

export default File;
